module.exports = __webpack_public_path__ + "static/media/trophy-bronze.da4dc64e.svg";